function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _templateObject9() {
  var data = _taggedTemplateLiteral(["\n    &.isSelected {\n      font-weight: bold;\n    }\n\n    &.hasIcon {\n      margin-left: ", ";\n    }\n  "]);

  _templateObject9 = function _templateObject9() {
    return data;
  };

  return data;
}

function _templateObject8() {
  var data = _taggedTemplateLiteral(["\n      > path {\n        fill: ", ";\n      }\n    "]);

  _templateObject8 = function _templateObject8() {
    return data;
  };

  return data;
}

function _templateObject7() {
  var data = _taggedTemplateLiteral(["\n    transform: rotateZ(0deg);\n    transition: 0.2s transform;\n\n    &.open {\n      transform: rotateZ(-180deg);\n    }\n\n    ", ";\n  "]);

  _templateObject7 = function _templateObject7() {
    return data;
  };

  return data;
}

function _templateObject6() {
  var data = _taggedTemplateLiteral(["\n    align-items: center;\n    display: flex;\n    margin-right: ", ";\n  "]);

  _templateObject6 = function _templateObject6() {
    return data;
  };

  return data;
}

function _templateObject5() {
  var data = _taggedTemplateLiteral(["\n    border: 2px solid ", ";\n    border-radius: 10px;\n    color: ", ";\n    cursor: pointer;\n    display: flex;\n    justify-content: space-between;\n    padding: ", " ", ";\n\n    &:hover,\n    &.open {\n      border-color: ", ";\n    }\n  "]);

  _templateObject5 = function _templateObject5() {
    return data;
  };

  return data;
}

function _templateObject4() {
  var data = _taggedTemplateLiteral(["\n  align-items: center;\n  display: flex;\n"]);

  _templateObject4 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3() {
  var data = _taggedTemplateLiteral(["\n            min-width: 220px;\n          "]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n            min-width: ", ";\n          "]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n    align-items: center;\n\n    ", "\n\n    &", " {\n      ", " {\n        background-color: ", ";\n        border: 2px solid ", ";\n        border-radius: 10px;\n        color: ", ";\n        margin-top: 16px;\n      }\n\n      ", " {\n        padding: ", ";\n        color: ", ";\n\n        &:hover {\n          background-color: ", ";\n          color: ", ";\n          font-weight: bold;\n        }\n\n        &.disabled {\n          color: ", ";\n        }\n      }\n    }\n\n    ", " {\n      ", ";\n\n      &.disabled {\n        ", " {\n          color: ", ";\n        }\n      }\n    }\n\n    ", " {\n      margin-right: ", ";\n      padding: 0;\n    }\n  "]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

import React from "react";
import styled, { css } from "styled-components";
import classnames from "classnames";
import { Icon } from "@cf-design-system/icon";
import { Dropdown as BaseDropdown, DropdownStyles, PopoverStyles } from "@diana-ui/dropdown";
var StyledDropdown = styled(BaseDropdown)((_ref) => {
  var {
    headerWidth,
    theme
  } = _ref;
  return css(_templateObject(), theme.typography.detailText, PopoverStyles.StyledPortal, DropdownStyles.List, theme.colors.white, theme.colors.black, theme.colors.black, DropdownStyles.Item, theme.spaceUnit.xs, theme.colors.black, theme.colors.grey.grey25, theme.colors.black, theme.colors.grey.grey100, DropdownStyles.StyledPopover, !!headerWidth ? css(_templateObject2(), headerWidth) : css(_templateObject3()), CustomHeader, theme.colors.grey.grey100, DropdownStyles.StyledLabel, theme.spaceUnit.xs);
});
var ItemWrapper = styled.span(_templateObject4());
var CustomHeader = styled.div((_ref2) => {
  var {
    theme
  } = _ref2;
  return css(_templateObject5(), theme.colors.grey.grey100, theme.colors.black, theme.spaceUnit.xxs, theme.spaceUnit.xs, theme.colors.black);
});
var CustomSpan = styled.span((_ref3) => {
  var {
    theme
  } = _ref3;
  return css(_templateObject6(), theme.spaceUnit.xxs);
});
var CustomHeaderIcon = styled(Icon)((_ref4) => {
  var {
    disabled,
    theme
  } = _ref4;
  return css(_templateObject7(), disabled && css(_templateObject8(), theme.colors.grey.grey100));
});
var CustomItemText = styled(DropdownStyles.ItemText)((_ref5) => {
  var {
    theme
  } = _ref5;
  return css(_templateObject9(), theme.spaceUnit.xs);
});

var Dropdown = (_ref6) => {
  var {
    headerIcon,
    headerWidth,
    placeholder,
    ref,
    selectedItem,
    text
  } = _ref6,
      props = _objectWithoutProperties(_ref6, ["headerIcon", "headerWidth", "placeholder", "ref", "selectedItem", "text"]);

  var renderHeader = isVisible => /*#__PURE__*/React.createElement(CustomHeader, null, /*#__PURE__*/React.createElement(CustomSpan, null, headerIcon && /*#__PURE__*/React.createElement(Icon, {
    name: headerIcon,
    fill: "#BFBFBF"
  }), /*#__PURE__*/React.createElement(CustomItemText, {
    className: classnames(headerIcon && "hasIcon")
  }, text !== null && text !== void 0 ? text : selectedItem ? selectedItem.text : placeholder)), /*#__PURE__*/React.createElement(CustomHeaderIcon, {
    className: classnames(isVisible && "open"),
    disabled: props.disabled || props.items.length === 0,
    name: "chevron-down",
    fill: "#BFBFBF"
  }));

  var renderItem = (item, isSelected) => /*#__PURE__*/React.createElement(ItemWrapper, null, item.icon && /*#__PURE__*/React.createElement(Icon, {
    name: item.icon,
    fill: "#BFBFBF"
  }), /*#__PURE__*/React.createElement(CustomItemText, {
    className: classnames(item.icon && "hasIcon", isSelected && "isSelected")
  }, item.text));

  return /*#__PURE__*/React.createElement(StyledDropdown, _extends({
    headerWidth: headerWidth,
    renderHeader: renderHeader,
    renderItem: renderItem
  }, props));
};

export default Dropdown;